const API_BASE = '/api';

export const calendarService = {
    // Obter URL de autorização Google
    async getAuthUrl() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/calendar/auth-url`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao obter URL de autorização');
        }
        
        return response.json();
    },

    // Conectar conta Google (após callback)
    async connect(code) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/calendar/connect`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ code })
        });
        
        if (!response.ok) {
            throw new Error('Erro ao conectar Google Calendar');
        }
        
        return response.json();
    },

    // Desconectar conta Google
    async disconnect() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/calendar/disconnect`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao desconectar Google Calendar');
        }
        
        return response.json();
    },

    // Verificar estado da conexão
    async getStatus() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/calendar/status`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            return { connected: false };
        }
        
        return response.json();
    },

    // Sincronizar reservas com Google Calendar
    async syncBookings() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/calendar/sync`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao sincronizar calendário');
        }
        
        return response.json();
    },

    // Adicionar reserva ao calendário
    async addBookingToCalendar(bookingId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/calendar/add-booking/${bookingId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao adicionar ao calendário');
        }
        
        return response.json();
    },

    // Remover reserva do calendário
    async removeBookingFromCalendar(bookingId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/calendar/remove-booking/${bookingId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao remover do calendário');
        }
        
        return response.json();
    }
};

export default calendarService;
